import { supabase } from "@/utils/supabase-client";

export default async function signInWithGoogle() {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options:{
      redirectTo: `/router`,
    }
  });
}
